// Onboarding Stage Enums
export enum TenantOnboardStep {
    TENANT_CREATION = 'TENANT_CREATION',
    BUSINESS_CREATION = 'BUSINESS_CREATION',
    SUBSCRIPTION = 'SUBSCRIPTION',
    VENDOR_DETAILS = 'VENDOR_DETAILS',
    POS_SETUP = 'POS_SETUP',
    TENANT_NOTES = 'TENANT_NOTES',
    ONBOARDING_PROCESS = 'ONBOARDING_PROCESS',
}

// Substep Enums for each stage
export enum TenantCreationSubstep {
    CREATE_TENANT = 'CREATE_TENANT',
    CREATE_NOTIFICATION_CONTEXT = 'CREATE_NOTIFICATION_CONTEXT',
    CREATE_ADMIN_USER = 'CREATE_ADMIN_USER',
    CREATE_ES_INDEX = 'CREATE_ES_INDEX',
    CREATE_REDMINE_PROJECT = 'CREATE_REDMINE_PROJECT',
}

export enum BusinessCreationSubstep {
    UPSERT_BUSINESS = 'UPSERT_BUSINESS',
    SETUP_FIELD_MAPPING = 'SETUP_FIELD_MAPPING',
}

export enum SubscriptionSubstep {
    SAVE_SUBSCRIPTION = 'SAVE_SUBSCRIPTION',
    CREATE_ONE_TIME_PACK_INVOICE = 'CREATE_ONE_TIME_PACK_INVOICE',
    UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS',
    APPLY_BUSINESS_CONFIG = 'APPLY_BUSINESS_CONFIG',
    SETUP_TICKETDESK_MODULE = 'SETUP_TICKETDESK_MODULE',
    SETUP_FILE_IMPORT = 'SETUP_FILE_IMPORT',
    SETUP_LEAD_MANAGEMENT = 'SETUP_LEAD_MANAGEMENT',
    SETUP_COMMERCE_CONNECT = 'SETUP_COMMERCE_CONNECT',
    SETUP_FLIPSELL = 'SETUP_FLIPSELL',
    SETUP_REQUEST_HANDLERS = 'SETUP_REQUEST_HANDLERS',
    ADD_ONBOARDING_USERS = 'ADD_ONBOARDING_USERS',
    ASSIGN_MODULE_OWNERS = 'ASSIGN_MODULE_OWNERS',
    SETUP_SUPERSET_MODULE = 'SETUP_SUPERSET_MODULE',
    REDMINE_TASK_CREATION = 'REDMINE_TASK_CREATION',
    OIR_FORM_REDMINE_TICKET_CREATION = 'OIR_FORM_REDMINE_TICKET_CREATION',
}

export enum VendorDetailsSubstep {
    SAVE_PROVIDER_CONFIG = 'SAVE_PROVIDER_CONFIG',
}

export enum PosSetupSubstep {
    SAVE_POS_DETAILS = 'SAVE_POS_DETAILS',
    VERIFY_BILL_SYNC = 'VERIFY_BILL_SYNC',
}

export enum TenantNotesSubstep {
    SAVE_NOTES = 'SAVE_NOTES',
}

export enum OnboardingProcessSubstep {
    SAVE_ONBOARDING_USERS = 'SAVE_ONBOARDING_USERS',
    CREATE_DASHBOARD_ACCOUNTS = 'CREATE_DASHBOARD_ACCOUNTS',
    SEND_WELCOME_EMAILS = 'SEND_WELCOME_EMAILS',
    CREATE_DISCORD_POST = 'CREATE_DISCORD_POST',
}

// Permission values stored in onboarding_users_tenant_access.permissions
export const ONBOARDING_USER_PERMISSIONS = [
    'canManageUsers',
    'canEditAssignedModulesOnly',
    'canViewAssignedModulesOnly',
] as const

export type OnboardingUserPermission =
    (typeof ONBOARDING_USER_PERMISSIONS)[number]

export const ONBOARDING_USER_PERMISSION_LABELS: Record<
    OnboardingUserPermission,
    string
> = {
    canManageUsers: 'Can manage users',
    canEditAssignedModulesOnly: 'Can edit assigned modules only',
    canViewAssignedModulesOnly: 'Can view assigned modules only',
}

// Union type of all substep enums
export type TenantOnboardSubstep =
    | TenantCreationSubstep
    | BusinessCreationSubstep
    | SubscriptionSubstep
    | VendorDetailsSubstep
    | PosSetupSubstep
    | TenantNotesSubstep
    | OnboardingProcessSubstep

// Supporting Enums

export enum VerificationType {
    TENANT = 'TENANT',
    USER = 'USER',
}

export enum CasaRetailType {
    Apparel = 'Apparel',
    Grocery = 'Grocery',
    Electronics = 'Electronics',
    FnB = 'F&B',
    Pharmacy = 'Pharmacy',
}

export const RETAIL_TYPE_OPTIONS = Object.entries(CasaRetailType).map(
    ([key, value]) => ({ key, label: value })
)
